import Icon from "@mui/icons-material/AccessTime";
import StaffAttendanceList from "./StaffAttendanceList";

export default {
  list: StaffAttendanceList,
  icon: Icon,
  label: "Staff Attendance",
  options: { label: "Staff Attendance" },
  name: "employeesAttendance",
};
